module.exports = __webpack_public_path__ + "img/logo_Agrial SAT.771531e5.png";